import {
  Button,
  cn,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Alert,
  AlertDescription,
  AlertTitle,
  Label,
  Checkbox,
  Heading,
} from "@ogt/ui";

import type { LabelMode } from "../../components/Map/transitMap/constants";

interface ToolsPopoverProps {
  isDesktop: boolean;
  streetViewVisible: boolean;
  mobileSidebarOpen: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  hasAnyFilter: boolean;
  copied: boolean;
  onCopyLink: () => void;
  onClearAll: () => void;
  labelMode: LabelMode;
  onLabelModeChange: (mode: LabelMode) => void;
}

function ToolsPopover({
  isDesktop,
  streetViewVisible,
  open,
  onOpenChange,
  hasAnyFilter,
  copied,
  onLabelModeChange,
  onCopyLink,
  onClearAll,
  labelMode,
}: ToolsPopoverProps) {
  return (
    <div className="shrink-0">
      <Popover open={open} onOpenChange={onOpenChange}>
        <PopoverTrigger asChild>
          <Button
            variant="secondary"
            size="small"
            showIcon
            activated={open}
            aria-pressed={open}
            iconName={open ? "x" : "menu"}
            iconPosition="left"
          >
            {open ? "Verktyg" : "Verktyg"}
          </Button>
        </PopoverTrigger>
        <PopoverContent
          align="end"
          sideOffset={16}
          alignOffset={-16}
          className={cn(
            "rounded border-white/60!",
            "bg-white/90!",
            "supports-[backdrop-filter:blur(1px)]:bg-white/60!",
            "backdrop-blur-md backdrop-saturate-100",
            "shadow-[0_8px_30px_rgba(0,0,0,0.10),0_0_0_1px_rgba(0,0,0,0.05),inset_0_1px_0_rgba(255,255,255,0.90)]!"
          )}
          style={{
            backgroundImage:
              "linear-gradient(145deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.02) 60%, rgba(255,255,255,0.08) 100%)",
          }}
        >
          <Heading as="h3">Kartverktyg</Heading>
          <hr className="my-4 border-t-[var(--semantic-color-divider-secondary)]" />

          {copied && (
            <Alert variant="success" dismissible showIcon className="mt-4 mb-6">
              <AlertTitle>
                <span className="pr-[70px] flex">Kopierad!</span>{" "}
              </AlertTitle>
              <AlertDescription>
                Nu kan du enkelt dela länken vidare.
              </AlertDescription>
            </Alert>
          )}

          <Button
            showIcon
            iconName="copy"
            variant="secondary"
            onClick={onCopyLink}
            className="mb-2 w-full"
          >
            Kopiera länk till kartan
          </Button>
          <Button
            showIcon
            iconName="trashcan"
            variant="secondary"
            onClick={onClearAll}
            disabled={!hasAnyFilter}
            className="disabled:opacity-70 w-full"
          >
            Rensa alla val
          </Button>
          <hr className="my-4 border-t-[var(--semantic-color-divider-secondary)]" />

          <div className="flex flex-col " id="placenames-section">
            <Heading as="h5">Platsnamn</Heading>

            <Label className="flex flex-row! items-center gap-2 cursor-pointer">
              <Checkbox
                id="place-names-toggle"
                checked={labelMode === "icon+name"}
                onCheckedChange={(v) =>
                  onLabelModeChange(v === true ? "icon+name" : "icon")
                }
              />
              <span>Visa platsnamn</span>
            </Label>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}

export default ToolsPopover;
